import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { AuthService } from './auth.service';
import { NgxSpinnerService } from "ngx-spinner";

@Injectable({
  providedIn: 'root'
})

export class AuthGuard {
  VadlidUer = false;

  constructor(private authService: AuthService, private router: Router, private spinner: NgxSpinnerService) { };

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.VadlidUer) {
      return true;
    } else {

      return this.authService.ValidateToken().pipe(
        map(data => {
          if (data === false) {
            this.VadlidUer = false;
            this.router.navigate(['/login-failed']);
            return false;
          }
          this.spinner.hide();
          this.VadlidUer = true;
          return true;
        }),
        catchError(() => {
          this.spinner.hide();
          this.VadlidUer = false;
          this.router.navigate(['/login-failed']);
          return of(false);
        }),
      );
    }
  }

  async checkValidateToken() {
    this.authService.ValidateToken()
      .subscribe({
        next: (res: any) => {
          this.spinner.hide();
          this.VadlidUer = true;
          return true;
        },
        error: (err: any) => {
          this.spinner.hide();
          this.VadlidUer = false;
          this.router.navigate(['/login-failed']);
          return false;
        }
      })
  }

}
